import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import DownloadPageContainer from './components/DownloadPageContainer'

const router = new Router({
    mode: 'history',
    base: '/',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: DownloadPageContainer
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})

export default router
